import { Navigate, Route, Routes } from "react-router-dom";
import { getToken } from "./lib/api";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { StoresPage } from "./pages/StoresPage";
import { ProductsPage } from "./pages/ProductsPage";
import { OrdersPage } from "./pages/OrdersPage";
import { InventoryPage } from "./pages/InventoryPage";
import { ConnectorsPage } from "./pages/ConnectorsPage";
import { SyncJobsPage } from "./pages/SyncJobsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { ProductEditorPage } from "./pages/ProductEditorPage";
import { CollectionPage } from "./pages/CollectionPage";
import { PricingTemplatesPage } from "./pages/PricingTemplatesPage";

function Protected() {
  return getToken() ? <AppShell /> : <Navigate to="/login" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<Protected />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/stores" element={<StoresPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/new" element={<ProductEditorPage />} />
        <Route path="/products/:id" element={<ProductEditorPage />} />
        <Route path="/collection" element={<CollectionPage />} />
        <Route path="/pricing-templates" element={<PricingTemplatesPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/connectors" element={<ConnectorsPage />} />
        <Route path="/sync-jobs" element={<SyncJobsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
